// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f6b1ac6","239":"593a6bfc","453":"def57dd1","455":"6b17bc07"}[chunkId] + ".chunk.js";
};